import React, { Component } from "react";
import { Button, Grid, Menu, Message, Segment } from "semantic-ui-react";
import { Map, Marker, Polygon, Polyline, GoogleApiWrapper } from "google-maps-react";
import findKey from "lodash/findKey";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";

export class GeofenceTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      errorShow: false,
      errorList: [],
      successShow: false,
      successList: [],
      fenceId: 0,
      initialCenter: {
        lat: 43.64,
        lng: -79.39
      },
      zoomLevel: 14,
      triangleCoords: [],
      polygonClosed: false,
      stadiumOptions: [],
      salesOptions: []
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setFenceList = this.setFenceList.bind(this);
    this.saveCoords = this.saveCoords.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);
    this.clearCoords = this.clearCoords.bind(this);
  }
  componentDidMount = () => {
    this.setState({
      isMounted: true
    });

    this.fetchData();
  };
  componentDidUpdate = prevProps => {
    if (this.props.google !== prevProps.google) {
      // The relevant props have changed
      this.loadMap();
    }
  };
  componentWillUnmount = () => {};
  fetchData = () => {
    return request.get(this, "api:/geofence", {}, this.setFenceList);
  };
  handleChange = e => {
    let fence = e.target.dataset.id;
    this.setState({ fenceId: fence });
    return request.get(this, `api:/geofence/${fence}`, {}, this.setFence);
  };
  handleSubmit = () => {
    this.setState({
      isLoading: true,
      errorShow: false,
      errorList: [],
      successShow: false,
      successList: []
    });
    return request.put(
      this,
      `api:/geofence/${this.state.fenceId}`,
      {
        coords: this.state.triangleCoords
      },
      this.saveCoords
    );
  };
  setFence = result => {
    // Don't change centre and zoomLevel unless there are points
    if (result.points[0] !== undefined) {
      this.setState({
        zoomLevel: 0,
        triangleCoords: []
      });
      this.setState({
        initialCenter: result.defaults.initial_center,
        zoomLevel: result.defaults.zoom_level,
        polygonClosed: true
      });
      this.updateCoords(result.points);
    }
    return result;
  };
  setFenceList = result => {
    let stadium = this.state.stadiumOptions;
    let sales = this.state.salesOptions;
    for (let i = 0; i < result.length; i++) {
      if (result[i].type === "stadium") {
        stadium.push({
          key: result[i].id,
          id: result[i].id,
          name: result[i].name
        });
      } else {
        sales.push({
          key: result[i].id,
          id: result[i].id,
          name: result[i].name
        });
      }
    }
    this.setState({
      stadiumOptions: stadium,
      salesOptions: sales,
      isLoading: false
    });
  };
  saveCoords = result => {
    this.setState({
      successShow: true,
      successList: [result.message],
      isLoading: false
    });
  };
  onMapClicked = (mapProps, map, clickEvent) => {
    // Add point
    if (this.state.polygonClosed) {
      alert("this geofence cannot be modified, please clear first");
      return;
    }

    let latlng = clickEvent.latLng.toJSON();
    let latitude = latlng.lat - 0;
    let longitude = latlng.lng - 0;
    let coords = this.state.triangleCoords;

    coords.push({ lat: latitude, lng: longitude });
    if (this.state.polygonClosed) {
      coords.push(coords[0]);
    }
    this.setState({ triangleCoords: [] });
    this.updateCoords(coords);
  };
  onPolyClicked = (props, poly, clickEvent) => {
    console.log('poly clicked');
    // Remove point
    let latlng = clickEvent.latLng.toJSON();
    let latitude = latlng.lat.toFixed(3) - 0;
    let longitude = latlng.lng.toFixed(3) - 0;
    let coords = this.state.triangleCoords;
    coords.pop();
    let result = findKey(coords, function(o, a) {
      let latmin = latitude - 0.0002;
      let latmax = latitude + 0.0002;
      let lngmin = longitude - 0.0002;
      let lngmax = longitude + 0.0002;
      return (
        o.lat > latmin && o.lat < latmax && (o.lng > lngmin && o.lng < lngmax)
      );
    });

    if (result > -1) {
      coords.splice(result, 1);
    }
    coords.push(coords[0]);

    this.setState({ triangleCoords: [] });
    this.updateCoords(coords);
  };
  onMarkerClicked = (props, marker, clickEvent) => {
    if (this.state.polygonClosed) {
      alert("this geofence cannot be modified, please clear first");
      return;
    }

    // Remove point
    let latlng = clickEvent.latLng.toJSON();
    let latitude = latlng.lat;
    let longitude = latlng.lng;
    let coords = this.state.triangleCoords;
    let markerCount = Object.keys(coords).length
    let result = findKey(coords, function(o, a) {
      let latmin = latitude - 0.000000002;
      let latmax = latitude + 0.000000002;
      let lngmin = longitude - 0.000000002;
      let lngmax = longitude + 0.000000002;
      return (
        o.lat > latmin && o.lat < latmax && (o.lng > lngmin && o.lng < lngmax)
      );
    });

    // Closing polygon
    if (+result === 0 && markerCount > 2) {
      coords.push(coords[0]);
      this.setState({ triangleCoords: [], polygonClosed: true });
      this.updateCoords(coords);
      return;
    }

    this.setState({ triangleCoords: [] });

    if (result > -1) {
      coords.splice(result, 1);
    }

    // Update coords if there are any markers left
    if (typeof coords[0] !== "undefined") {
      this.updateCoords(coords);
    }
  };
  clearCoords = () => {
    this.setState({ triangleCoords: [], polygonClosed: false });
  };
  editCoords = () => {
    let coords = this.state.triangleCoords;
    if (this.state.polygonClosed && coords[0] !== undefined) {
      this.setState({
        zoomLevel: 0,
        triangleCoords: []
      });
      this.setState({
        initialCenter:this.state.initialCenter,
        zoomLevel: this.state.zoomLevel,
        polygonClosed: false
      });
      coords.pop();
      this.updateCoords(coords);
    }
    return coords;
  };
  updateCoords = coords => {
    this.setState({ triangleCoords: coords });
  };
  render() {
    const {
      errorShow,
      errorList,
      successShow,
      successList,
      isLoading,
      fenceId,
      polygonClosed,
      triangleCoords,
      zoomLevel,
      initialCenter,
      stadiumOptions,
      salesOptions
    } = this.state;
    return (
      <Segment basic loading={isLoading}>
        <Message negative hidden={!errorShow}>
          <p>{errorList[0]}</p>
        </Message>
        <Message positive hidden={!successShow}>
          <p>{successList[0]}</p>
        </Message>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              {fenceId > 0 && (
                <Button floated="right" primary onClick={this.handleSubmit}>
                  Save
                </Button>
              )}
              {fenceId > 0 && (
                <Button floated="right" onClick={this.editCoords}>
                  Edit
                </Button>
              )}
              {fenceId > 0 && (
                <Button floated="right" onClick={this.clearCoords}>
                  Clear
                </Button>
              )}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              <Menu fluid vertical inverted>
                {stadiumOptions.map((value, index) => (
                  <Menu.Item
                    key={value.id}
                    data-id={value.id}
                    link
                    active={fenceId === value.id}
                    content={value.name}
                    onClick={this.handleChange}
                  />
                ))}
                {salesOptions.map((value, index) => (
                  <Menu.Item
                    key={value.id}
                    data-id={value.id}
                    link
                    active={fenceId === value.id}
                    content={value.name}
                    onClick={this.handleChange}
                  />
                ))}
              </Menu>
            </Grid.Column>
            <Grid.Column width={12}>
              <Map
                google={this.props.google}
                containerStyle={{
                  position: "relative",
                  height: "auto",
                  clear: "both",
                  visibility: fenceId > 0 ? "visible": "hidden" 
                }}
                style={{
                  position: "relative",
                  display: "block",
                  width: "100%",
                  height: "400px"
                }}
                className="map"
                initialCenter={initialCenter}
                center={initialCenter}
                zoom={zoomLevel}
                onClick={this.onMapClicked}
              >
                {polygonClosed && <Polygon
                  paths={triangleCoords}
                  strokeColor="#0000FF"
                  strokeOpacity={0.8}
                  strokeWeight={2}
                  fillColor="#0000FF"
                  fillOpacity={0.35}
                  // onClick={this.onPolyClicked}
                />}
                {!polygonClosed && <Polyline
                  path={triangleCoords}
                  strokeColor="#0000FF"
                  strokeOpacity={0.8}
                  strokeWeight={2}
                />}
                {triangleCoords.map((value, index) => (
                  <Marker
                    key={index}
                    position={value}
                    title="Click to remove"
                    onClick={this.onMarkerClicked}
                  />
                ))}
              </Map>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

const GoogleWrapper = GoogleApiWrapper((props) => ({
  apiKey: props.apiKey
}))(GeofenceTab);

export default class Geofence extends Component {
  render() {
    return (<div><GoogleWrapper apiKey={this.context.settings.hidden.google_api_key} /></div>)
  }
}
Geofence.contextType = AppContext;